import { render, staticRenderFns } from "./CoachPage.vue?vue&type=template&id=a35f0cf0&"
import script from "./CoachPage.vue?vue&type=script&lang=js&"
export * from "./CoachPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "CoachPage.vue"
export default component.exports